// src/components/GlobalUploadProgress.js
import React from 'react';
import { FiX, FiCheckCircle, FiAlertCircle, FiUploadCloud } from 'react-icons/fi';

const GlobalUploadProgress = ({ uploads, onClose }) => {
    const activeUploads = Object.entries(uploads);

    if (activeUploads.length === 0) return null;

    return (
        <div className="global-upload-container">
            <div className="global-upload-header">
                <h6>Uploads ({activeUploads.length})</h6>
            </div>
            <div className="global-upload-list">
                {activeUploads.map(([id, task]) => (
                    <div key={id} className={`global-upload-item ${task.status}`}>
                        <div className="upload-item-icon">
                            {task.status === 'uploading' && <FiUploadCloud />}
                            {task.status === 'success' && <FiCheckCircle className="text-success" />}
                            {task.status === 'error' && <FiAlertCircle className="text-danger" />}
                        </div>
                        <div className="upload-item-info">
                            <div className="upload-item-top">
                                <span className="upload-name">{task.name}</span>
                                <span className="upload-percent">
                                    {task.status === 'error' ? 'Failed' : `${task.progress}%`}
                                </span>
                            </div>
                            <div className="upload-progress-track">
                                <div 
                                    className={`upload-progress-bar ${task.status}`} 
                                    style={{ width: `${task.progress}%` }}
                                ></div>
                            </div>
                            {task.status === 'error' && (
                                <span className="upload-error-msg">{task.error}</span>
                            )}
                        </div>
                        {task.status !== 'uploading' && (
                            <button className="upload-close-btn" onClick={() => onClose(id)}>
                                <FiX />
                            </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GlobalUploadProgress;